import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/download'
import UseScript from 'components/commons/UseScript/UseScript'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  if (process.browser) {
    UseScript('https://js.hsforms.net/forms/embed/v2.js')
  }
  return (
    <>
      <CustomHead
        keyword={'資料ダウンロード 資料請求 ホワイトペーパー 調査資料'}
        image={'https://www.i3design.jp/OGP_logo.png'}
        url={'https://www.i3design.jp/download'}
        title="資料ダウンロード | i3DESIGN アイスリーデザイン"
        description="アプリケーション開発やUI/UXに関する調査資料、戦略フレームワークなど、さまざまなジャンルのお役立ち資料を提供しています。ぜひダウンロードしてご活用ください。"
      />
      <Template />
    </>
  )
}

export default Download
